import { createAction, props } from '@ngrx/store';
import { SapConnectionStatus } from 'app/models/reducers/sap-synchronization';
import { EquipmentDetailsDto } from '@festo-ax/smartenance-shared-ui';

export enum SapSynchronizationActionTypes {
  AcceptSapConnectorUsageAgreement = '[SapSynchronization] AcceptTermsOfUsage',
  AcceptSapConnectorUsageAgreementSuccess = '[SapSynchronization] AcceptTermsOfUsageSuccess',
  AcceptSapConnectorUsageAgreementFail = '[SapSynchronization] AcceptTermsOfUsageFail',
  TestSapConnection = '[SapSynchronization] TestSapConnection',
  TestSapConnectionSuccess = '[SapSynchronization] TestSapConnectionSuccess',
  TestSapConnectionFail = '[SapSynchronization] TestSapConnectionFail',
  LoadSapEquipment = '[SapSynchronization] LoadSapEquipment',
  GetSapEquipment = '[SapSynchronization] GetSapEquipment',
  GetSapEquipmentSuccess = '[SapSynchronization] GetSapEquipmentSuccess',
  GetSapEquipmentFail = '[SapSynchronization] GetSapEquipmentFail',
  ResetSapEquipmentInformation = '[SapSynchronization] ResetSapEquipmentInformation',
  SkipSapEquipmentLoading = '[SapSynchronization] SkipSapEquipmentLoading',
  SendTestRequest = '[SapSynchronization] SendTestRequest',
  SendTestRequestSuccess = '[SapSynchronization] SendTestRequestSuccess',
  SendTestRequestFail = '[SapSynchronization] SendTestRequestFail'
}

export const AcceptSapConnectorUsageAgreement = createAction(SapSynchronizationActionTypes.AcceptSapConnectorUsageAgreement);
export const AcceptSapConnectorUsageAgreementSuccess = createAction(SapSynchronizationActionTypes.AcceptSapConnectorUsageAgreementSuccess);
export const AcceptSapConnectorUsageAgreementFail = createAction(
  SapSynchronizationActionTypes.AcceptSapConnectorUsageAgreementFail,
  props<{ error: unknown }>()
);
export const TestSapConnection = createAction(SapSynchronizationActionTypes.TestSapConnection);
export const TestSapConnectionSuccess = createAction(
  SapSynchronizationActionTypes.TestSapConnectionSuccess,
  props<{ sapConnectionStatus: SapConnectionStatus }>()
);
export const TestSapConnectionFail = createAction(SapSynchronizationActionTypes.TestSapConnectionFail, props<{ error: unknown }>());
export const sendTestRequest = createAction(SapSynchronizationActionTypes.SendTestRequest, props<{ topic: string; request: unknown }>());
export const sendTestRequestSuccess = createAction(SapSynchronizationActionTypes.SendTestRequestSuccess, props<{ responseData: unknown }>());
export const sendTestRequestFail = createAction(SapSynchronizationActionTypes.SendTestRequestFail, props<{ error: unknown }>());

export const loadSapEquipment = createAction(
  SapSynchronizationActionTypes.LoadSapEquipment,
  props<{ sapEquipmentId: string | null; isSapMachine: boolean | null }>()
);
export const getSapEquipment = createAction(SapSynchronizationActionTypes.GetSapEquipment, props<{ sapEquipmentId: string }>());
export const getSapEquipmentSuccess = createAction(
  SapSynchronizationActionTypes.GetSapEquipmentSuccess,
  props<{ sapEquipment: EquipmentDetailsDto }>()
);
export const getSapEquipmentFail = createAction(SapSynchronizationActionTypes.GetSapEquipmentFail, props<{ error: unknown }>());
export const resetSapEquipmentInformation = createAction(SapSynchronizationActionTypes.ResetSapEquipmentInformation);
export const skipSapEquipmentLoading = createAction(SapSynchronizationActionTypes.SkipSapEquipmentLoading);
